import { motion } from "framer-motion";
import { riseFade } from "@/lib/motion";

const ways = [
  {
    title: "On your iPhone",
    body: "Fully on-device. No account, no servers, nothing leaves your phone. This is the invite-only pilot.",
  },
  {
    title: "On the web",
    body: "Sign in to use Myelina in a browser, with AI insights, clinician sharing and buddy features. Your entries are stored in our cloud database, see the privacy policy for exactly what and where.",
  },
];

const TwoWaysToUse = () => (
  <section
    aria-labelledby="two-ways-heading"
    className="relative py-20 sm:py-28 bg-background border-t border-border/50"
  >
    <div className="container mx-auto px-6 sm:px-10 lg:px-16">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-10% 0px" }}
        variants={riseFade}
        className="max-w-2xl mx-auto text-center mb-12 sm:mb-16"
      >
        <h2
          id="two-ways-heading"
          className="font-display text-foreground text-display-lg"
        >
          Two ways to use <span className="italic text-primary">Myelina.</span>
        </h2>
      </motion.div>

      <ul className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10 max-w-4xl mx-auto">
        {ways.map((w, i) => (
          <motion.li
            key={w.title}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-10% 0px" }}
            variants={riseFade}
            transition={{ delay: i * 0.07 }}
            className="space-y-3 text-center md:text-left"
          >
            <div className="text-[10px] tracking-[0.32em] uppercase text-primary">
              {w.title}
            </div>
            <p className="text-muted-foreground leading-relaxed">{w.body}</p>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);

export default TwoWaysToUse;
